import React, { useState } from "react";
import { connect } from "react-redux";
import { Tabs, Tab } from "react-bootstrap";
import typeCampaignCategorySelected from "./TypeCampaignCategorySelected";
import constantsReportCampaign from "./constants/reportCampaign";
import reportActions from "../../../store/actions/reportCampaignAction";

const TabSeparationReport = ({
  whichTypeSelect,
  separationActive,
  setTypeSeparationDataChart,
  emptyCampaignsDataSeparation,
  campaignTypeCategorySelected,
  dateFrom,
  dateTo,
  campaignID,
  getCampaignsDataSeparationWithCampaignName,
  getCampaignsDataSeparationWithCampaignType,
}) => {
  const clickSeparationItemHandler = (selectedKey) => {
    const separate = selectedKey.target
      .getAttribute("data-rb-event-key")
      .toUpperCase();
    emptyCampaignsDataSeparation({});
    setTypeSeparationDataChart({
      separation: separate,
    });

    switch (whichTypeSelect) {
      case constantsReportCampaign.whichTypeSelect.CAMPAIGN:
        getCampaignsDataSeparationWithCampaignName({
          campaign_id: campaignID,
          separation: separate,
          date_from: dateFrom,
          date_to: dateTo,
        });
        break;

      case constantsReportCampaign.whichTypeSelect.TYPE_CAMPAIGNS:
        getCampaignsDataSeparationWithCampaignType({
          campaign_type: campaignTypeCategorySelected,
          separation: separate,
          date_from: dateFrom,
          date_to: dateTo,
        });
        break;
    }
  };

  const deactivateTabs = () => {
    const tabsActive = document.querySelectorAll(
      ".nav.nav-tabs .nav-item.nav-link.active"
    );

    tabsActive.forEach((tabActive) => {
      tabActive.classList.remove("active");
    });
  };

  let tabsTag;

  if (whichTypeSelect === constantsReportCampaign.whichTypeSelect.CAMPAIGN) {
    tabsTag = (
      <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 container-tab-separation-report pt-3 pr-3">
        <div dir="rtl">
          <Tabs
            className="d-inline-flex flex-lg-nowrap pt-1"
            onClick={(selectedKey) => {
              clickSeparationItemHandler(selectedKey);
            }}
          >
            <Tab eventKey="publisher" title="به تفکیک نمایش دهنده"></Tab>
            <Tab eventKey="position" title="به تفکیک جایگاه"></Tab>
            <Tab eventKey="time" title="به تفکیک زمان"></Tab>
          </Tabs>
        </div>
      </div>
    );
  } else if (campaignTypeCategorySelected == typeCampaignCategorySelected.ALL) {
    tabsTag = <></>;
  } else {
    tabsTag = (
      <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 container-tab-separation-report pt-3 pr-3">
        <div dir="rtl">
          <Tabs
            onClick={(selectedKey) => {
              clickSeparationItemHandler(selectedKey);
            }}
            className="flex-nowrap pt-1"
          >
            <Tab eventKey="campaign" title="به تفکیک کمپین"></Tab>
            <Tab eventKey="publisher" title="به تفکیک نمایش دهنده"></Tab>
            {/* <Tab eventKey="advertise" title="به تفکیک تبلیغ"></Tab> */}
            <Tab eventKey="position" title="به تفکیک جایگاه"></Tab>
            <Tab eventKey="time" title="به تفکیک زمان"></Tab>
          </Tabs>
        </div>
      </div>
    );
  }

  return <>{tabsTag}</>;
};

const mapStateToProps = (state) => {
  return {
    whichTypeSelect: state.reportCampaign.which_type_select,
    campaignTypeCategorySelected:
      state.reportCampaign.campaign_type_category_selected,
    dateFrom: state.reportCampaign.date_from,
    dateTo: state.reportCampaign.date_to,
    campaignID: state.reportCampaign.campaign_id_selected,
    separationActive: state.reportCampaign.which_separation_active,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    emptyCampaignsDataSeparation: (action) => {
      dispatch({
        type: reportActions.EMPTY_CAMPAIGNS_DATA_SEPARATION_FAILED,
        payload: action,
      });
    },
    setTypeSeparationDataChart: (action) => {
      dispatch({
        type: reportActions.SET_TYPE_SEPARATION_DATA_CHART,
        payload: action,
      });
    },
    getCampaignsDataSeparationWithCampaignName: (action) => {
      dispatch({
        type: reportActions.GET_CAMPAIGNS_DATA_SEPARATION_WITH_CAMPAIGN_NAME,
        payload: action,
      });
    },
    getCampaignsDataSeparationWithCampaignType: (action) => {
      dispatch({
        type: reportActions.GET_CAMPAIGNS_DATA_SEPARATION_WITH_CAMPAIGN_TYPE,
        payload: action,
      });
    },
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TabSeparationReport);
